import { ArticleCard } from 'data/global/types';
// This utility uses the reduce function to inject values into an array. This is better than injecting a new value with something like splice because this will allow us to treat the return value as immutable and return an entirely new array with the updated value.

// Example: we need to inject null into a specific index in arrays of some article cards so that a subscribe card will be displayed.
// To do that, we can use this utility and pass through the array of article cards, the index where we want the subscribe card to appear
// and `null` (since that is how the component will decide to render the subscribe card.

export function injectValueIntoArray(
  array: ArticleCard[],
  insertAtIndex: number,
  newValueToInject: null,
) {
  return array.reduce((acc: (ArticleCard | null)[], curr, index) => {
    if (index === insertAtIndex) {
      // If the function is iterating on the index where we want to inject a new value, it will return everything in the accumulator, followed by the new value, followed by the current value that we are iterating on so we can continue iterating over the array.
      return [...acc, newValueToInject, curr];
    }
    return [...acc, curr];
  }, []);
}
